module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABN0lEQVR42r3XsUrDUBSH8aPoEwhC30OdBF9Ggjc1ubm3Qah0COLQJ3DXUZ9JOoqTgpMIxhMJHFEXz4cd/mP6/WjDgco0pkWIedl13ZZO1rDNsskXZZ0vdSIhpvtQp14Rt4b4x3jM10NP4w99329IGWf7Gn92IEA8vWj3UCcDACBY3AAjoozpyYFwxg0AECRuAIAgcQMABIkbACBI3AAAQeIGAAgSNwBAkLgBAILEDeBGFEWxDeIGAIiVI44BclKlA42/jvG3UKUjnXj25we+/uahat7pxUTnNdSzY3q24XnlZ5vGhSJgnCNgnCNgnCNgnCNgnCN+xPWBG0fcjXDE/Qj93LvvCBjnCEfct9N0tvcbQkLMV444/yb0RdcNgLRyxDki5sfPP6dt2+6Ok3VtOp/vNM35RCcfA8ElJeD1CosAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/p-close_2x.png
// module id = 1004
// module chunks = 0